// @flow
import React, { PureComponent } from 'react';
import styled from 'styled-components';
import { connect } from 'react-redux';
import { GrayContainer } from '../../../ui/containers';

const MainPhoto = styled.div`
  background: url("https://photos.verinmuebles.com/th/${props => props.image}");
  background-size: cover;
  background-position: 0 50%;
  width: 100%;
  padding-top: 100%;
  display: block;
  position: relative;
`;

const FeatureText = styled.div`
  color: #666;
  font-size: 12px;
`;

const KindBuildingText = styled.div`
  color: white;
  font-weight: bold;
  font-size: 12px;
`;

const FeaturesContainer = styled.div`
  border-bottom: solid 1px #333;
  padding: 10px 0;
`

const Container = GrayContainer.extend`
  flex-direction: column;
  text-decoration: none;
`.withComponent('a');

const Description = FeatureText.extend`
  padding: 10px 0;
  word-wrap: break-word;
`;

const Code = styled.div`
  position: absolute;
  left: 0;
  bottom: 0;
  font-size: 10px;
  font-weighT: bold;
  padding: 2px 5px;
  background: rgba(0,0,0,0.7);
  color: white;
`;

const Label = styled.span`
  background: ${props => props.background};
  color: white;
  text-shadow: 1px 1px 3px #000;
  text-align: center;
  line-height: 100%;
  padding: 5px 10px;
  position: absolute;
  top: 7px;
  left: -7px;
  font-size: 14px;
`;

class BuildingCard extends PureComponent {
  props: {
    detail: Object,
    pageInfo: Object,
  }

  render() {
    const {
      bInImages,
      permalink,
      bCodes,
      kindOffer,
      kindBuilding,
      sector0,
      comments,
      bInLabels,
    } = this.props.detail;
    const { pageInfo = {} } = this.props;
    const description = comments.length < 140 ? comments : `${comments.substring(0, 140)}...`;
    const { page = {} } = pageInfo;
    return (
      <Container href={`/${permalink}-${bCodes.building_code}.html`} target="_blank">
        <MainPhoto image={bInImages[0].image}>
          <Code>Cód. {bCodes.building_code}</Code>
          {bInLabels.length > 0 && <Label
            background={bInLabels[0].label_color ? bInLabels[0].label_color : page.color_base}
          >{bInLabels[0].label.name}</Label>}
        </MainPhoto>
        <FeaturesContainer>
          <FeatureText>{kindOffer.offer_reference_res}</FeatureText>
          <KindBuildingText>{kindBuilding.building_name}</KindBuildingText>
          <FeatureText>{sector0.sector_name}</FeatureText>
        </FeaturesContainer>
        <Description>{description}</Description>
      </Container>
    )
  }
}

export default connect(state => ({
  pageInfo: state.client.pageInfo,
}))(BuildingCard);



// WEBPACK FOOTER //
// ./src/components/BuildingsView/BuildingsResult/BuildingCard/index.js